<template>
  <div>
    <v-toolbar class="mb-2" id="title">
      <v-toolbar-title>
        {{ $t("message.news.news") }}
      </v-toolbar-title>
    </v-toolbar>
    <template v-if="data.length > 0">
      <v-card>
        <v-list class="noBackColor">
          <template v-for="item in data">
            <v-list-item :key="item.news">
              <v-list-item-action class="pr-0">
                <v-list-item-subtitle class="news_date">{{ $d(1000 * item.ctime, 'short', $store.getters.langs[$i18n.locale].locale) }}</v-list-item-subtitle>
              </v-list-item-action>
              <v-list-item-content>
                <v-tooltip top :max-width="toolTip_width">
                  <template v-slot:activator="{ on }">
                    <v-list-item-title>
                      <span v-on="on" v-html="item.news"></span>
                    </v-list-item-title>
                  </template>
                  <span v-html="item.news"></span>
                </v-tooltip>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </template>
    <template v-else>
      <div class="pa-4 mb-2">
        <span class="grey--text">{{ $t("message.common.no_id", { id: $t("message.news.news") }) }}</span>
      </div>
    </template>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";

export default {
  mixins: [
    res_list,
    http_error
  ],
  data: function(){
    return {
      module_id: "56",
      data: [],
      progress: 0,
      progress_overlay: false,
      toolTip_width: 0
    }
  },
  methods: {
    handleResize() {
      this.get_slideItem_width();
    },
    get_slideItem_width(){
      const $title = document.getElementById('title');
      this.toolTip_width = $title.clientWidth;
    }
  },
  mounted(){
    this.get_data('news', []);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
.noBackColor {
  background-color: inherit !important;
}
.v-list {
  overflow-y: auto;
  max-height: 200px;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
}
.news_date {
  width: 108px;
  padding-top: 2px;
}
.v-list-item__action {
  align-self: flex-start !important;
}
.v-list-item__content {
  align-self: flex-start !important;
}

</style>
